import React, { useState, useEffect } from 'react';
import { Box, Checkbox, CheckboxGroup, Button, Grid, GridItem, FormControl, FormLabel, Select, Spinner } from '@chakra-ui/react';
import axios from 'axios';
import { BASE_URL } from '../../Globalapi/Globalapi';

// Permissions data
const rolesPermissions = {
  student: [
    'View Grades', 
    'Submit Assignments', 
    'Participate in Forums',
    'Student profile'
  ],
  guardian: [
    'View Child’s Grades', 
    'Communicate with Teachers'
  ],
  staff: [
    'Manage Classes', 
    'Grade Assignments', 
    'Access Reports',
    'Staff Details'
  ],
  admin: [
    'Manage Users', 
    'Access All Reports', 
    'System Configuration',
    'Admin View'
  ]
};

// All possible permissions including subitem names
const allPermissions = [
  'View Grades', 
  'Submit Assignments', 
  'Participate in Forums', 
  'View Child’s Grades', 
  'Communicate with Teachers', 
  'Manage Classes', 
  'Grade Assignments', 
  'Access Reports', 
  'Manage Users', 
  'Access All Reports', 
  'System Configuration',
  'Student profile',
  'Staff Details',
  'Admin View',
  'Exam Details', 
  'Exam Results', 
  'Grade', 
  'Student result', 
  'Class Teacher result', 
  'Parent result', 
  'Subject result',
  'Upload', 
  'Student View', 
  'Staff View'
];

const RolePermissionAssignment = () => {
  const [userTypes, setUserTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedRole, setSelectedRole] = useState('');
  const [selectedPermissions, setSelectedPermissions] = useState(allPermissions.map(() => 0));

  useEffect(() => {
    // Fetch user types from the API
    axios.get(`${BASE_URL}/admin/student/user_type.php`)
      .then(response => {
        if (response.data.success) {
          setUserTypes(response.data.data);
        }
        setLoading(false);
      })
      .catch(error => {
        console.error('Error fetching user types:', error);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    if (selectedRole) {
      const permissionsForRole = rolesPermissions[selectedRole] || [];
      const updatedPermissions = allPermissions.map(permission =>
        permissionsForRole.includes(permission) ? 1 : 0
      );
      setSelectedPermissions(updatedPermissions);
    } else {
      setSelectedPermissions(new Array(allPermissions.length).fill(0));
    }
  }, [selectedRole]);

  const handleRoleChange = (event) => {
    setSelectedRole(event.target.value);
  };

  const handlePermissionChange = (permissions) => {
    setSelectedPermissions(permissions.map(permission => permission ? 1 : 0));
  };

  const handleSave = () => {
    console.log('Permissions saved:', selectedPermissions);
  };

  return (
    <Box p={5}>
      <FormControl mb={4}>
        <FormLabel>Select User Type</FormLabel>
        {loading ? (
          <Spinner />
        ) : (
          <Select placeholder="Select role" onChange={handleRoleChange}>
            {userTypes.map((type) => (
              <option key={type.id} value={type.utype}>
                {type.utype.charAt(0).toUpperCase() + type.utype.slice(1)}
              </option>
            ))}
          </Select>
        )}
      </FormControl>
      <FormLabel mb={4}>Permissions</FormLabel>
      <CheckboxGroup value={selectedPermissions} onChange={handlePermissionChange}>
        <Grid templateColumns="repeat(4, 1fr)" gap={4} width="100%">
          {allPermissions.map((permission, index) => (
            <GridItem key={permission}>
              <Checkbox value={index} isChecked={selectedPermissions[index] === 1}>
                {permission}
              </Checkbox>
            </GridItem>
          ))}
        </Grid>
      </CheckboxGroup>
      <Button mt={4} colorScheme="teal" onClick={handleSave}>Save Permissions</Button>
    </Box>
  );
};

export default RolePermissionAssignment;
